import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Row } from "react-bootstrap";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default () => {
  const moduleName = `warranties`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const [state, setState] = useState(``);
  const [name, setName] = useState(``);
  const [slug, setSlug] = useState(``);
  const [submitted, setSubmitted] = useState(false);

  const [id, setId] = useState();
  const params = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])

  const handleChangeState = (value) => setState(value);
  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (appReducer.warranties_edit != undefined && id != undefined) {
      let row = appReducer.warranties_edit.data;
      if (row) {
        setName(row.name);
        setSlug(row.slug)
        setState({
          value: row.state,
          label: row.state == `active` ? `فعال` : `غیرفعال`,
        });
      }
    }
  }, [appReducer.warranties_edit]);

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.warranties_store != undefined && appReducer.warranties_store.error == false) ||
        (appReducer.warranties_update != undefined && appReducer.warranties_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.warranties_store,
    appReducer.warranties_update
  ])

  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  return <Template.Form>
    <Template.Input required value={slug} label="نام" name="slug" type="text" />
    <Template.Input required value={name} label="توضیحات" name="name" type="text" />
    <Template.SingleSelect
      withLabel
      required
      placeholder="وضعیت"
      onChange={handleChangeState}
      name="state"
      value={state}
      options={[
        {
          value: "active",
          label: "فعال",
        },
        {
          value: "deactive",
          label: "غیرفعال",
        },
      ]}
    />
    <Template.Button
      label="ذخیره"
      
      onClick={handleClick}
    />
  </Template.Form>;
};